import React from 'react'
import { Navigate } from 'react-router-dom'

const NotFound: React.FC = () => <Navigate to='/' />

export default NotFound
